import { PaymentType } from "@/store/subscription/billing/type";

export const PAYMENT_TYPES: PaymentType[] = [
  PaymentType.CLASSIC,
  PaymentType.REAL_TIME,
];
